export default "__VITE_ASSET__fe8527a4__"